import { render, staticRenderFns } from "./RentalService.yaml?vue&type=template&id=5a367dc3&component"
import script from "./RentalService.yaml?vue&type=script&lang=ts&component"
export * from "./RentalService.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports